<div class="sidenav-container">
  <!-- Backdrop -->
  <div class="sidenav-backdrop" [class.open]="isOpen" (click)="onBackdropClick()">
  </div>

  <!-- Sidenav Panel -->
  <div class="sidenav-panel" [class.open]="isOpen">
    <!-- Header -->
    <div class="sidenav-header">
      <button class="sidenav-close-button" type="button" (click)="onToggle()">
        <iconify-icon icon="bitcoin-icons:cross-outline"></iconify-icon>
      </button>

      <div class="sidenav-header-content">
        <a routerLink="/home" class="sidenav-header-logo"><img src="/img/greatday_logo.svg" [alt]="'header.logo' | translate"></a>
        @if (userName$ | async; as userName) {
          <div class="sidenav-user-greeting">{{ 'sidenav.welcomeUser' | translate:{ name: userName } }}</div>
        } @else {
          <div class="sidenav-user-greeting">{{ 'sidenav.welcome' | translate }}</div>
        }
      </div>
    </div>

    <!-- Navigation Items -->
    <nav class="sidenav-nav">
      <div class="nav-section">
        <a mat-button class="nav-item" routerLink="/home" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: true}" (click)="closeSidenav.emit()">
          <iconify-icon icon="heroicons-outline:home"></iconify-icon>
          <span>{{ 'sidenav.navigation.home' | translate }}</span>
        </a>

        <a mat-button class="nav-item" routerLink="/avatars" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}" (click)="closeSidenav.emit()">
          <iconify-icon icon="heroicons-outline:users"></iconify-icon>
          <span>{{ 'avatars.title' | translate }}</span>
        </a>

        <a mat-button class="nav-item" routerLink="/billing" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}" (click)="closeSidenav.emit()">
          <iconify-icon icon="heroicons-outline:banknotes"></iconify-icon>
          <span>{{ 'sidenav.navigation.subscriptionPricing' | translate }}</span>
        </a>

        <a mat-button class="nav-item" routerLink="/settings" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}" (click)="closeSidenav.emit()">
          <iconify-icon icon="heroicons-outline:cog-6-tooth"></iconify-icon>
          <span>{{ 'settings.title' | translate }}</span>
        </a>

        <a mat-button class="nav-item" routerLink="/matches" routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}" (click)="closeSidenav.emit()">
          <iconify-icon icon="heroicons-outline:heart"></iconify-icon>
          <span>{{ 'matches.title' | translate }}</span>
          @if (matchActionableCount$ | async; as count) {
            @if (count > 0) {
              <span class="sidenav-badge">{{ count }}</span>
            }
          }
        </a>

        @if (isManagerOrAdmin$ | async) {
          <a mat-button class="nav-item" routerLink="/manager/feedback" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: false}" (click)="closeSidenav.emit()">
            <iconify-icon icon="heroicons-outline:clipboard-document-list"></iconify-icon>
            <span>{{ 'managerDashboard.navLink' | translate }}</span>
          </a>
        }
      </div>
    </nav>

    <!-- Footer -->
    <div class="sidenav-footer">
      <div class="footer-buttons-wrapper">
        <button mat-button class="nav-item" (click)="openLanguageSelector()">
          <span class="nav-item-flag">{{ currentLanguageFlag }}</span>
          <span>{{ currentLanguageLabel }}</span>
        </button>

        <button mat-button class="nav-item" (click)="openFeedback()">
          <iconify-icon icon="heroicons-outline:chat-bubble-left-right"></iconify-icon>
          <span>{{ 'sidenav.navigation.feedback' | translate }}</span>
        </button>

        <button mat-button class="nav-item logout-button" (click)="logout()">
          <iconify-icon icon="circum:logout"></iconify-icon>
          <span>{{ 'settings.logout' | translate }}</span>
        </button>
      </div>

      @if (version) {
      <div class="version-info" (click)="showDebugInfo()">
        <span>v{{ version }}</span>
      </div>
      }
    </div>
  </div>
</div>